<div id="accordion">
  <div class="export-container" *ngIf="accordionItems.length">
    <dx-button
      class="export-btn"
      [text]="'COMMON.EXPORT-ALL' | translate"
      type="default"
      (click)="exportAll()"
    ></dx-button>
  </div>
  <dx-accordion 
    [items]="accordionItems" 
    [collapsible]="true"
    [multiple]="true"
    [animationDuration]="300"
    [selectedItems]="[]"
    class="questions-accordion"
  >
    <div *dxTemplate="let item of 'title'">
      <div class="question-header">
        {{ item.question.question }} ({{ getTotalCount(item) }})
      </div>    
    </div>
    <div *dxTemplate="let item of 'item'">
      <div class="accordion-content">
        @if(item.acceptedAnswers?.length || item.pendingAnswers?.length) {
          @if(item.showTabs) {
            <dx-tabs
              width="100%"
              [showNavButtons]="false"
              [dataSource]="item.tabs"
              displayExpr="text"
              valueExpr="key"
              [(selectedItem)]="item.selectedTab"
            ></dx-tabs>
            <app-table
              [data]="item.selectedTab?.key === 'accepted' ? item.acceptedAnswers : item.pendingAnswers"
              [columns]="item.selectedTab?.key === 'accepted' ? item.acceptedColumns : item.pendingColumns"
              [showSearch]="true"
              [searchPlacehoder]="'COMMON.SEARCH' | translate"
              [showExport]="true"
              [exportName]="'Employees list'"
              [rowStyleCallback]="rowStyleCallback"
              [showRowDetails]="getShowRowDetails(item.question.type)"
              [rowHasDetails]="hasAdditionalParticipants"
              [rowDetailTemplate]="additionalParticipantsTemplate"
              [templates]="{
                nameParticipantsTemplate: nameParticipantsTemplate
              }"
              [getAdditionalRows]="getAdditionalRows"
              [mapAdditionalRow]="mapAdditionalRow"
            ></app-table>
          } @else {
            <app-table
              [data]="item.acceptedAnswers?.length ? item.acceptedAnswers : item.pendingAnswers"
              [columns]="item.acceptedAnswers?.length ? item.acceptedColumns : item.pendingColumns"
              [showSearch]="true"
              [searchPlacehoder]="'COMMON.SEARCH' | translate"
              [showExport]="true"
              [exportName]="'Employees list'"
              [rowStyleCallback]="rowStyleCallback"
              [showRowDetails]="getShowRowDetails(item.question.type)"
              [rowHasDetails]="hasAdditionalParticipants"
              [rowDetailTemplate]="additionalParticipantsTemplate"
              [templates]="{
                nameParticipantsTemplate: nameParticipantsTemplate
              }"
              [getAdditionalRows]="getAdditionalRows"
              [mapAdditionalRow]="mapAdditionalRow"
            ></app-table>
          }

          <ng-template #additionalParticipantsTemplate let-data>
            <ng-container *ngIf="data.additionalParticipants?.length > 0">
              <ul class="additional-participants-list">
                <li *ngFor="let p of data.additionalParticipants">
                  {{ p.lastName }} {{ p.firstName }}
                </li>
              </ul>
            </ng-container>
          </ng-template>

          <ng-template #nameParticipantsTemplate let-data>
            <ng-container *ngIf="data.data as value">
              <span>{{ value.person.lastName }}</span>

              @if(value.additionalParticipants?.length > 0) {
                <span #tooltipTarget class="additional-participants">
                  +{{ value.additionalParticipants.length }}
                </span>

                <dx-tooltip
                  [target]="tooltipTarget"
                  showEvent="mouseenter"
                  hideEvent="mouseleave"
                  [hideOnOutsideClick]="false"
                >
                  <div *dxTemplate="let d = data; of: 'content'" class="tooltip-content">
                    <div *ngFor="let participant of value.additionalParticipants; let i = index">
                      {{ i + 1 }}. {{ participant.lastName }}, {{ participant.firstName }}
                    </div>
                  </div>
                </dx-tooltip>
              }
            </ng-container>
          </ng-template>
        } @else {
          <div class="no-answers-text">
            {{ 'TRAINING-QUESTIONNAIRE.PARTICIPATION.NO-ANSWERS' | translate }}
          </div>
        }
      </div>
    </div>
  </dx-accordion>
</div>